import React from "react";
import { Icon as NIcon, IIconProps } from "native-base";

export const Icon: React.FC<IIconProps> = (props) => {
  return <NIcon {...props} />;
};

export default Icon;
